module.exports = __webpack_public_path__ + "static/media/eq3-large_2x.49a30078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/eq3-large_2x.png
// module id = 772
// module chunks = 27